import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import PersonOffboardIcon from '@atlaskit/icon/core/person-offboard';
import { token } from '@atlaskit/tokens';

const messages = defineMessages({
	iconLabel: {
		id: 'update-work-item-fields-action-renderer.ui.action-card.single-select-user-picker-field.icon-label',
		defaultMessage: 'Single select user picker field icon',
		description: 'Label for the single select user picker field icon',
	},
});

export function SingleSelectUserPickerFieldIcon(): React.JSX.Element {
	const { formatMessage } = useIntl();
	return (
		<PersonOffboardIcon
			label={formatMessage(messages.iconLabel)}
			size="small"
			color={token('color.icon.subtle')}
		/>
	);
}
